import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantBidItem from './tenant-bid-item';
import TenantBidItemDetail from './tenant-bid-item-detail';
import TenantBidItemUpdate from './tenant-bid-item-update';
import TenantBidItemDeleteDialog from './tenant-bid-item-delete-dialog';

const TenantBidItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantBidItem />} />
    <Route path="new" element={<TenantBidItemUpdate />} />
    <Route path=":id">
      <Route index element={<TenantBidItemDetail />} />
      <Route path="edit" element={<TenantBidItemUpdate />} />
      <Route path="delete" element={<TenantBidItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantBidItemRoutes;
